export const hasEveryValues = <T>(arr1: T[], arr2: T[]) => {
  return arr1.every((i) => arr2?.includes(i));
};

export const hasSomeValues = <T>(arr1: T[], arr2: T[]) => {
  return arr1.some((i) => arr2?.includes(i));
};
